import { useEffect, useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Button, Table } from "react-bootstrap"
import Pagination from 'react-bootstrap/Pagination'

import { Switch } from "components/Inputs"
import { Filtros } from "components/Filtros"
import { CustomTooltip } from "components/Helpers"

import { formatDate, isDateTimeFormat } from "services/FormFunctions"

import iconOlho from "assets/icon_olho.png"

const btnStyle = "rounded-4 mx-2 my-auto btn btn-primary"
const btnVariant = "outline-primary"

const useSortableData = (items, config = null) =>
    {
        const [sortConfig, setSortConfig] = useState(config);
        
        const sortedItems = useMemo(() => {
          let sortableItems = [...items];
          if (sortConfig !== null) {
            sortableItems.sort((a, b) => {
                let aVal = a[sortConfig.key]
                let bVal = b[sortConfig.key]
                if(sortConfig.key === 'numProc')
                {
                    aVal = Number(aVal.replace('.', ''))
                    bVal = Number(bVal.replace('.', ''))
                }
                if (aVal < bVal) {
                    return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                if (aVal > bVal) {
                    return sortConfig.direction === 'ascending' ? 1 : -1;
                }
                return 0;
            }
            );
          }
          return sortableItems;
        }, [items, sortConfig]);
      
        const requestSort = key => {
          let direction = 'descending';
          if (sortConfig && sortConfig.key === key && sortConfig.direction === 'descending')
          {
            direction = 'ascending';
          }
          setSortConfig({ key, direction });
        }
      
        return { items: sortedItems, requestSort };
}

const HeaderTabela = ({headers, requestSort}) =>
{
    return (
        <thead>
            <tr>
                {
                    headers.map(
                        (col, index) =>
                        {
                            return(
                                col.sortable?
                                <th className="text-center align-middle" key={`col-${index}`} scope="col" onClick={() => requestSort(col.varName)} role={"button"}>{col.name}</th>
                                :
                                <th className="text-center align-middle" key={`col-${index}`} scope="col">{col.name}</th>
                            )
                        }
                    )
                }
            </tr>
        </thead>
    )
}

const LinhasTabela = ({headers, elements}) =>
{
    return (
        <tbody>
            {
                // Cada elemento é uma linha
                elements.map(
                    (element, indexRow) =>
                    {
                        return(
                            <tr key={`row-${indexRow}`}>
                                {
                                    // Eu tenho que pegar o elemento equivalente ao header dele
                                    headers.map(
                                        (column) =>
                                        {
                                            // Aqui eu vou pegar o elemento dentro do objeto
                                            // como a key pode ser enviada com pontos (autenticacao.funcionarios.0.nome), preciso fazer um loop pra entrar no obj
                                            const subVariables = column.varName.split('.')
                                            let cellContent = element
                                            for (let i = 0; i < subVariables.length; i++) 
                                            {
                                                cellContent = cellContent[subVariables[i]] 
                                            }

                                            let cellText = isDateTimeFormat(cellContent) ? formatDate(cellContent) : cellContent

                                            return(
                                                <td key={`${column.varName}-${indexRow}`} className="text-center align-middle">
                                                    {cellText}
                                                </td>
                                            )
                                        }
                                    )
                                }
                            </tr>
                        )
                    }
                )
            }
        </tbody>
    )
}

const PaginacaoTabela = ({currentPage, numPages, setPage}) =>
{
    function changePage(e, newCurrentPage)
    {
        setPage(newCurrentPage)
        e.currentTarget.blur()
    }

    return(
        <Pagination>
            <Pagination.Prev onClick={(e) => {changePage(e, currentPage-1)}} disabled={currentPage===1}/>
            <Pagination.Item onClick={(e) => {changePage(e, 1)}} active={currentPage===1}>{1}</Pagination.Item>

            {currentPage-3 > 1? <Pagination.Ellipsis onClick={(e) => {changePage(e, currentPage-3)}} /> : <></>}
            {currentPage-2 > 1? <Pagination.Item onClick={(e) => {changePage(e, currentPage-2)}}>{currentPage-2}</Pagination.Item> : <></>}
            {currentPage-1 > 1? <Pagination.Item onClick={(e) => {changePage(e, currentPage-1)}}>{currentPage-1}</Pagination.Item> : <></>}
            {currentPage > 1 && currentPage < numPages && numPages > 2 ? <Pagination.Item active={true}>{currentPage}</Pagination.Item> : <></>}
            {currentPage+1 < numPages? <Pagination.Item onClick={(e) => {changePage(e, currentPage+1)}}>{currentPage+1}</Pagination.Item> : <></>}
            {currentPage+2 < numPages? <Pagination.Item onClick={(e) => {changePage(e, currentPage+2); e.currentTarget.blur();}}>{currentPage+2}</Pagination.Item> : <></>}
            {currentPage+3 < numPages? <Pagination.Ellipsis onClick={(e) => {changePage(e, currentPage+3)}} /> : <></>}
            {numPages > 1? <Pagination.Item onClick={(e) => {changePage(e, numPages)}} active={currentPage===numPages}>{numPages}</Pagination.Item> : <></>}

            <Pagination.Next onClick={(e) => {changePage(e, currentPage+1)}} disabled={currentPage===numPages}/>
        </Pagination>
    )
}

const FiltroMostrarParticipo = ({handleChange}) =>
{
    return (<Switch Name={"filtroPart"} Label={"Ver apenas os que faço parte"} OnChange={handleChange} DefaultChecked={true} />)
}

export const ButtonVer = ({ url, state, text, altText, disabled }) =>
{
    const navigate = useNavigate()
    const Redirect = () => { navigate(url, {state: state}) }

    return (
        <CustomTooltip 
            htmlObj={<Button className={btnStyle} variant={btnVariant} disabled={disabled} onClick={Redirect}><img src={iconOlho} alt={altText} /></Button>} 
            text={text}/>
    )
}

export function Tabela({ title, headers, elements, msgNenhumEncontrado, filtros, filterParticipo, numPages, currentPage, setCurrentPage })
{
    const [todosItems, setTodosItems] = useState(elements)
    // Ordenar leva em consideração todos os itens
    const { items, requestSort } = useSortableData(todosItems)
    
    // Filtrar por participação do usuario
    const [switchEuParticipo, setSwitchEuParticipo] = useState(true)

    function handleFilterParticipo()
    {
        setSwitchEuParticipo(!switchEuParticipo)
    }

    useEffect(() => {
        let newListaProcs = elements
        if (switchEuParticipo)
        {
            newListaProcs = filterParticipo(elements)
        }
       setTodosItems(newListaProcs)
       // setCurrentPage(1)
    }, [switchEuParticipo, filterParticipo, elements])

    if (!elements || elements.length <= 0)
    {
        return (
            <div className = "d-flex flex-column align-items-center">
                <p className = "fw-bold mt-3 align-self-center">{title}</p>
                <FiltroMostrarParticipo handleChange={handleFilterParticipo} />
                <Filtros filtros={filtros} />
                <p className = "fw-bold mt-3 align-self-center">{msgNenhumEncontrado}</p>
            </div>
        )
    }
    
    return (
        <div className = "d-flex flex-column align-items-center">
            <p className = "fw-bold mt-3 align-self-center">{title}</p>
            <FiltroMostrarParticipo handleChange={handleFilterParticipo} />
            <Filtros filtros={filtros} />
            <Table hover>
                <HeaderTabela headers={headers} requestSort={requestSort}/>
                <LinhasTabela headers={headers} elements={items} />
            </Table>
            <PaginacaoTabela currentPage={currentPage} numPages={numPages} setPage={undefined}/>
        </div>
    )
}

export function TabelaBanco({ title, headers, elements, msgNenhumEncontrado, FiltrosTabela, pagination, setPage, sortBy })
{
    if (!elements || elements.length <= 0)
    {
        return (
            <div className = "d-flex flex-column align-items-center">
                <p className = "fw-bold mt-3 align-self-center">{title}</p>
                {FiltrosTabela}
                <p className = "fw-bold mt-3 align-self-center">{msgNenhumEncontrado}</p>
            </div>
        )
    }
    
    return (
        <div className = "d-flex flex-column align-items-center">
            <p className = "fw-bold mt-3 align-self-center">{title}</p>
            {FiltrosTabela}
            <Table hover>
                <HeaderTabela headers={headers} requestSort={sortBy} />
                <LinhasTabela headers={headers} elements={elements} />
            </Table>
            {!!pagination ? <PaginacaoTabela currentPage={pagination.currentPage} numPages={pagination.numPages} setPage={setPage}/> : <></>}
        </div>
    )
}
